import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { Hash } from "lucide-react";

interface QuoteIdentifierFieldProps {
  form: UseFormReturn<any>;
  isVisible?: boolean;
}

const QuoteIdentifierField = ({ form, isVisible = true }: QuoteIdentifierFieldProps) => {
  if (!isVisible) return null;

  return (
    <FormField
      control={form.control}
      name="externalIdentifier"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="flex items-center gap-2">
            <Hash className="h-4 w-4" />
            External Identifier (Optional)
          </FormLabel>
          <FormControl>
            <Input
              placeholder="Enter your system's quote ID/reference"
              {...field}
              value={field.value || ''}
              className="transition-colors"
            />
          </FormControl>
          <p className="text-xs text-muted-foreground">
            Link this quote to your internal quoting system for easy reference
          </p>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default QuoteIdentifierField;